import axios from "axios";

import { LOGIN_URL } from "../../config";

axios.interceptors.response.use((response) => response, (error) => {
    const { response } = error;

    if (response) {
        const { status } = response;
        const defaultUrl = window.location.href;

        if (status === 401) {
            window.location.href = defaultUrl.indexOf("/no-permissions") !== -1
                ? `${LOGIN_URL()}?referer=${encodeURI(defaultUrl)}`
                : LOGIN_URL();
        }
    }

    return Promise.reject(error);
});
